export const config = {
  // apiUrl: "https://cadenabackend.iworklab.com/api/v1",
  // baseUrl: "https://cadenabackend.iworklab.com/",

  apiUrl:  "https://cadenaapi.dev.vinove.com/api/v1",
  baseUrl: "https://cadenaapi.dev.vinove.com/",

};
